import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TR } from '../models/TR';
import { Step3 } from '../../../../shared/models/component-messages/mapaIN/step3';

@Component({
  selector: 'app-tR',
  templateUrl: './tR.component.html'
})
export class TRComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TR';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() tR: TR;
  @Input() labelTD = '';

    public step3 = new Step3();

  constructor() { }

  public ngOnInit() {
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

